import React, { useRef, useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Typography, Form, Input, Button, Row, Col, Select, message } from 'antd';
import { searchUsersAPI, fetchUsersName  } from 'services/users/users';
//sample data
import data from './sampleData';
import {fetchRoleListAPI} from 'services/shared/fetchLovList';
import { UserAccessContext } from 'context/userAccess';
const {Text} = Typography;
const { Option } = Select;

function SearchUserForm({onFinish}) {
	const { userAccess } = useContext(UserAccessContext);
    const navigate = useHistory();
    const formRef = useRef();
    const [ loading, setLoading ] = useState(false);
    const [roleList, setRolelist] = useState([]);

    //sample data
    const [filterData, setFilterData] = useState([]);
    //const [userNameList, setUserNameList] = useState([]);

   /* useEffect(() => {
		async function fetchData() {
			const userNames = await fetchUsersName();

			setFilterData(data);
			setUserNameList(userNames);
		}
		setLoading(true);
		fetchData();
		setLoading(false);
	}, []);*/

    useEffect(() => {
        async function fetchData() {
            const rolesList = await fetchRoleListAPI();
            
            setRolelist(rolesList);
        }
        fetchData();
    }, []);

   
    
    async function handleSubmit(formValues){
        // agent search api
        try {
            const result = await searchUsersAPI(formValues)
               
            setFilterData(result);
            onFinish(result);
            
            if(result.length <= 0){
                message.info('No results found');
            }
        }catch(error) {
            console.log("error", error)
        }
    }

    const roleOptions = roleList.map(data => (
		<Option key={data.role_id} value={data.role_name}>
			{data.role_name}
		</Option>
	));

    
    function clearSearch(){
        // @ts-ignore
        const { setFieldsValue } = formRef.current;
        setFieldsValue({ user_name: '', role_name: '', last_name: '', first_name: '', status: [] })
    }
    return (
        <div>
            <Form layout='vertical'
                onFinish={handleSubmit}
                ref={formRef}
            >
                {/* user fields */}
                <Row gutter={[8, 1]} align='bottom'>
                    <Col span={4} className="gutter-row">
                        <Form.Item
                            label='USER NAME    '
                            name="user_name"
                        >
                            <Input 
                              className='inv-input-uppercase'
                              placeholder='USER NAME'
                              maxLength={20}
                                //onFocus={userNameFocus}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                        <div style={{ marginLeft:5 ,marginRight:10, marginBottom: 8 }}>
                            <Text strong className="inv-filler-str">OR</Text>
                        </div>
                    </Col>
                    <Col span={3} className="gutter-row">
                        <Form.Item
                            label='ROLE'
                            name="role_name"
                        >
                            <Select 
                                placeholder="ROLE"
								showSearch
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
							>
								{roleOptions}
                             
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6} className="gutter-row">
                        <Form.Item
                            label='LAST NAME'
                            name="last_name"
                        >
                            <Input type='text' 
                                className='inv-input-uppercase'
                                placeholder='LAST NAME' 
                                maxLength={50}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6} className="gutter-row">
                        <Form.Item
                            label='FIRST NAME'
                            name="first_name"
                        >
                            <Input type='text' 
                                className='inv-input-uppercase'
                                placeholder='FIRST NAME'
                                maxLength={50}
                            />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={4}>
                        <Form.Item
                            label='STATUS'
                            name="status"
                        >
                            <Select placeholder="STATUS"
                                showSearch	
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                            >
                                <Option value='ACTIVE'>ACTIVE</Option>
                                <Option value='INACTIVE'>INACTIVE</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {/* buttons */}
                <Row gutter={[8, 1]} justify='end' align='bottom'>
                    <Col>
                        <Form.Item shouldUpdate>
                            {
                                ({ getFieldsValue }) => {
                                    const { user_name, role_name, last_name, first_name, status } = getFieldsValue();
                                    const disabled = !( user_name || role_name || last_name || first_name || status );

                                    return(
                                        <Row>
                                            <Button 
                                            className="login-form-button inv-button"
                                            type="primary" 
                                            htmlType='submit'
                                            disabled={disabled}
                                            >
                                                SEARCH
                                            </Button>
                                            <Button 
                                            className="form-button inv-button-right"
                                                onClick={clearSearch}
                                            >
                                                CLEAR
                                            </Button>
                                        </Row>
                                    )
                                }
                            }
                        </Form.Item>
                    </Col>
                </Row>
                {(userAccess['users'].create === 'TRUE')
                ?   <Row gutter={[8, 1]} justify='end' align='bottom'>
                        <Col className="gutter-row">
                            <Form.Item>
                                <Button 
                                    className="margin-bot-add"
                                    style={{ marginBottom: -5}}
                                    type="primary" 
                                    onClick={() => navigate.push('/user/add_user')}
                                    // disabled={ userAccess['users'].create }
                                >
                                    ADD USER
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
                }
            </Form>
        </div>
    );
}

export default SearchUserForm;